import React from 'react'
import { Skeleton, Stack } from '@mui/material';

export const EjesSkeleton = () => {
    return (
        <>
            <Stack
                direction={{xs: 'column', sm: 'column', md:'row'}}
                justifyContent="center"
                alignItems="center"
                spacing={1}
                sx={{
                    width: 'calc(100%)'
                }}
            >   
                <Skeleton variant='rectangular' width={300} height={320} animation="wave" />
                <Skeleton variant='rectangular' width={300} height={320} animation="wave" />
                <Skeleton variant='rectangular' width={300} height={320} animation="wave" />
                <Skeleton variant='rectangular' width={300} height={320} animation="wave" />
                
            </Stack>
        </>
    )
}
